import * as React from 'react';
import { AccordionDetails, Grid } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';

import { FAQ_BY_CATEGORY, CATEGORIES } from './constants';
import {
  containerStyles,
  StyledAccordion,
  StyledIconButton,
  HeadingText,
  QuestionText,
  AnswerText,
  AnswerList,
  AccordionSummaryStyled,
  accordionDetailsStyles,
  CategoryChip,
  AddIconStyled,
} from './styles';
import { Gapper } from '../../ui/utils';

export default function FaqsSection() {
  const [expanded, setExpanded] = React.useState(false);
  const [category, setCategory] = React.useState(CATEGORIES[0]);

  const handleChange = (panel) => (_e, isExp) => {
    setExpanded(isExp ? panel : false);
  };

  const handleCategoryClick = (category) => () => {
    setCategory(category);
  };

  return (
    <Gapper gap={50} sx={containerStyles}>
      <HeadingText align="center">FAQs</HeadingText>

      <Grid container spacing={1.5} justifyContent="center">
        {CATEGORIES.map((cat) => (
          <Grid item key={cat}>
            <CategoryChip
              label={cat}
              onClick={handleCategoryClick(cat)}
              isActive={category === cat}
            />
          </Grid>
        ))}
      </Grid>

      <Gapper gap={20}>
        {FAQ_BY_CATEGORY[category].map((item, idx) => {
          const key = `${category}-${idx}`;
          const isOpen = expanded === key;

          return (
            <StyledAccordion
              key={key}
              isOpen={isOpen}
              expanded={isOpen}
              onChange={handleChange(key)}
              disableGutters
              square={false}
            >
              <AccordionSummaryStyled isOpen={isOpen}>
                <QuestionText>{item.q}</QuestionText>

                <StyledIconButton isOpen={isOpen}>
                  {isOpen ? <RemoveIcon /> : <AddIconStyled />}
                </StyledIconButton>
              </AccordionSummaryStyled>
              <AccordionDetails sx={accordionDetailsStyles}>
                {Array.isArray(item.a) ? (
                  <AnswerList>
                    {item.a.map((listItem, listIdx) => (
                      <li key={listIdx}>{listItem}</li>
                    ))}
                  </AnswerList>
                ) : (
                  <AnswerText>{item.a}</AnswerText>
                )}
              </AccordionDetails>
            </StyledAccordion>
          );
        })}
      </Gapper>
    </Gapper>
  );
}
